import React from 'react';
import Checkbox from '../Checkbox';

/**
 * Checkbox/Large — Figma 4109:324
 * 32px selector · title `typo-h4` · description `typo-body`.
 */
const CheckboxLarge = (props) => <Checkbox {...props} size="large" />;

export default CheckboxLarge;
